import { render, staticRenderFns } from "./customerLogDetail.vue?vue&type=template&id=5ebc3055&scoped=true&"
import script from "./customerLogDetail.vue?vue&type=script&lang=js&"
export * from "./customerLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerLogDetail.vue?vue&type=style&index=0&id=5ebc3055&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc3055",
  null
  
)

export default component.exports